import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    nav_application: "Application",
    nav_services: "Services",
    nav_contact: "Contact",
    nav_login: "Se connecter",
    nav_logout: "Déconnexion",
    nav_dashboard: "Dashboard",
    
    // Hero Section
    hero_location: "Lubumbashi, RDC",
    hero_title_1: "Suivez les",
    hero_title_2: "pannes",
    hero_title_3: "en temps réel",
    hero_description: "Application communautaire pour signaler et suivre les coupures d'électricité (SNEL) et d'eau (REGIDESO) à Lubumbashi",
    hero_download: "Télécharger l'App Android",
    hero_web_access: "Accès Web",
    hero_ios_soon: "App iOS disponible bientôt",
    
    // Features Section
    features_title: "Pourquoi",
    features_title_highlight: "Safi Energy",
    features_subtitle: "Une solution communautaire pour mieux gérer les coupures de services essentiels",
    feature_realtime: "Temps réel",
    feature_realtime_desc: "Recevez des alertes instantanées sur les pannes dans votre quartier",
    feature_community: "Communautaire",
    feature_community_desc: "Signalez et partagez les informations avec vos voisins",
    feature_map: "Carte interactive",
    feature_map_desc: "Visualisez les zones affectées sur une carte détaillée",
    feature_reliable: "Fiable",
    feature_reliable_desc: "Données vérifiées par la communauté pour plus de précision",
    
    // Services Section
    services_title: "Nos",
    services_title_highlight: "Services",
    services_subtitle: "Solutions solaires fiables et durables pour votre indépendance énergétique",
    service_batteries: "Batteries Solaires",
    service_batteries_desc: "Batteries Lithium (LiFePO4) de haute qualité, offrant une durée de vie supérieure à 5 ans",
    service_batteries_feature1: "Alimentation 24h/24",
    service_batteries_feature2: "Haute performance certifiée",
    service_panels: "Panneaux Solaires",
    service_panels_desc: "Panneaux solaires de 610W haute performance pour une production optimale",
    service_panels_feature1: "Rendement optimal",
    service_panels_feature2: "Résistants aux intempéries",
    service_installation: "Installation",
    service_installation_desc: "Installation professionnelle par nos équipes certifiées à Lubumbashi et environs",
    service_installation_feature1: "Équipe professionnelle",
    service_installation_feature2: "Service après-vente",
    
    // CTA Section
    cta_title: "Téléchargez l'application",
    cta_title_highlight: "maintenant",
    cta_description: "Rejoignez la communauté Safi Energy et restez informé des coupures d'électricité et d'eau dans votre quartier",
    cta_download: "Télécharger l'APK",
    cta_web: "Version Web",
    
    // Contact Section
    contact_title: "Contactez",
    contact_title_suffix: "-nous",
    contact_description: "Notre équipe est disponible pour répondre à toutes vos questions concernant nos services et solutions énergétiques.",
    contact_address: "Adresse",
    contact_phone: "Téléphone",
    contact_email: "Email",
    contact_zone_title: "Zone d'intervention",
    contact_zone_description: "Nous intervenons dans les régions suivantes:",
    contact_follow: "Suivez-nous",
    
    // Footer
    footer_tagline: "Énergie renouvelable",
    footer_copyright: "© 2024 Safi Energy. Tous droits réservés.",
    footer_privacy: "Politique de confidentialité",
    footer_terms: "Conditions d'utilisation",
    footer_delete: "Supprimer le compte",
    
    // Dashboard
    dashboard_refresh: "Actualiser",
    dashboard_electricity: "Électricité",
    dashboard_water: "Eau",
    dashboard_total: "Total",
    dashboard_report: "Signaler",
    dashboard_new_outage: "Nouvelle panne",
    dashboard_click_to_report: "Cliquez pour signaler",
    dashboard_active_outages: "Pannes actives",
    dashboard_active_snel: "Pannes actives (SNEL)",
    dashboard_active_regideso: "Pannes actives (REGIDESO)",
    dashboard_reported: "Pannes signalées",
    dashboard_map: "Carte",
    dashboard_list: "Liste",
    dashboard_all: "Tout",
    dashboard_no_outages: "Aucune panne signalée",
    dashboard_all_working: "Tout fonctionne normalement",
    dashboard_resolved: "Résolu",
    dashboard_severity_low: "Faible",
    dashboard_severity_medium: "Moyen",
    dashboard_severity_high: "Élevé",
    
    // Auth Modal
    auth_title: "Safi Energy",
    auth_description: "Connectez-vous ou créez un compte pour signaler des pannes",
    auth_login_tab: "Connexion",
    auth_signup_tab: "Inscription",
    auth_email: "Email",
    auth_password: "Mot de passe",
    auth_name: "Nom complet",
    auth_phone: "Téléphone (optionnel)",
    auth_login_btn: "Se connecter",
    auth_signup_btn: "Créer un compte",
    auth_login_success: "Connexion réussie !",
    auth_signup_success: "Compte créé avec succès !",
    auth_login_error: "Erreur de connexion",
    auth_signup_error: "Erreur lors de la création du compte",
    
    // Report Outage Modal
    report_title: "Signaler une panne",
    report_description: "Aidez votre communauté en signalant les coupures d'électricité ou d'eau",
    report_type: "Type de panne",
    report_electricity: "Électricité",
    report_water: "Eau",
    report_location: "Localisation",
    report_location_placeholder: "Sélectionnez votre quartier",
    report_severity: "Gravité",
    report_severity_low: "Faible - Intermittent",
    report_severity_medium: "Moyen - Partiel",
    report_severity_high: "Élevé - Total",
    report_description_label: "Description",
    report_description_placeholder: "Décrivez la situation (ex: Coupure depuis 2h, tout le quartier est affecté...)",
    report_submit: "Signaler la panne",
    report_success: "Panne signalée avec succès !",
    report_error: "Erreur lors du signalement",
    report_login_required: "Connectez-vous pour signaler une panne",
  },
  
  en: {
    // Navigation
    nav_application: "Application",
    nav_services: "Services",
    nav_contact: "Contact",
    nav_login: "Login",
    nav_logout: "Logout",
    nav_dashboard: "Dashboard",
    
    // Hero Section
    hero_location: "Lubumbashi, DRC",
    hero_title_1: "Track",
    hero_title_2: "outages",
    hero_title_3: "in real time",
    hero_description: "Community application to report and track electricity (SNEL) and water (REGIDESO) outages in Lubumbashi",
    hero_download: "Download Android App",
    hero_web_access: "Web Access",
    hero_ios_soon: "iOS app coming soon",
    
    // Features Section
    features_title: "Why",
    features_title_highlight: "Safi Energy",
    features_subtitle: "A community solution to better manage essential service outages",
    feature_realtime: "Real-time",
    feature_realtime_desc: "Receive instant alerts about outages in your neighborhood",
    feature_community: "Community",
    feature_community_desc: "Report and share information with your neighbors",
    feature_map: "Interactive map",
    feature_map_desc: "View affected areas on a detailed map",
    feature_reliable: "Reliable",
    feature_reliable_desc: "Community-verified data for more accuracy",
    
    // Services Section
    services_title: "Our",
    services_title_highlight: "Services",
    services_subtitle: "Reliable and sustainable solar solutions for your energy independence",
    service_batteries: "Solar Batteries",
    service_batteries_desc: "High quality Lithium (LiFePO4) batteries, offering a lifespan of over 5 years",
    service_batteries_feature1: "24/7 power supply",
    service_batteries_feature2: "Certified high performance",
    service_panels: "Solar Panels",
    service_panels_desc: "High performance 610W solar panels for optimal production",
    service_panels_feature1: "Optimal efficiency",
    service_panels_feature2: "Weather resistant",
    service_installation: "Installation",
    service_installation_desc: "Professional installation by our certified teams in Lubumbashi and surroundings",
    service_installation_feature1: "Professional team",
    service_installation_feature2: "After-sales service",
    
    // CTA Section
    cta_title: "Download the app",
    cta_title_highlight: "now",
    cta_description: "Join the Safi Energy community and stay informed about electricity and water outages in your area",
    cta_download: "Download APK",
    cta_web: "Web Version",
    
    // Contact Section
    contact_title: "Contact",
    contact_title_suffix: " us",
    contact_description: "Our team is available to answer all your questions about our services and energy solutions.",
    contact_address: "Address",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_zone_title: "Service area",
    contact_zone_description: "We operate in the following regions:",
    contact_follow: "Follow us",
    
    // Footer
    footer_tagline: "Renewable energy",
    footer_copyright: "© 2024 Safi Energy. All rights reserved.",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms & Conditions",
    footer_delete: "Delete Account",
    
    // Dashboard
    dashboard_refresh: "Refresh",
    dashboard_electricity: "Electricity",
    dashboard_water: "Water",
    dashboard_total: "Total",
    dashboard_report: "Report",
    dashboard_new_outage: "New outage",
    dashboard_click_to_report: "Click to report",
    dashboard_active_outages: "Active outages",
    dashboard_active_snel: "Active outages (SNEL)",
    dashboard_active_regideso: "Active outages (REGIDESO)",
    dashboard_reported: "Reported outages",
    dashboard_map: "Map",
    dashboard_list: "List",
    dashboard_all: "All",
    dashboard_no_outages: "No outages reported",
    dashboard_all_working: "Everything is working normally",
    dashboard_resolved: "Resolved",
    dashboard_severity_low: "Low",
    dashboard_severity_medium: "Medium",
    dashboard_severity_high: "High",
    
    // Auth Modal
    auth_title: "Safi Energy",
    auth_description: "Login or create an account to report outages",
    auth_login_tab: "Login",
    auth_signup_tab: "Sign up",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Full name",
    auth_phone: "Phone (optional)",
    auth_login_btn: "Login",
    auth_signup_btn: "Create account",
    auth_login_success: "Login successful!",
    auth_signup_success: "Account created successfully!",
    auth_login_error: "Login error",
    auth_signup_error: "Error creating account",
    
    // Report Outage Modal
    report_title: "Report an outage",
    report_description: "Help your community by reporting electricity or water outages",
    report_type: "Outage type",
    report_electricity: "Electricity",
    report_water: "Water",
    report_location: "Location",
    report_location_placeholder: "Select your neighborhood",
    report_severity: "Severity",
    report_severity_low: "Low - Intermittent",
    report_severity_medium: "Medium - Partial",
    report_severity_high: "High - Total",
    report_description_label: "Description",
    report_description_placeholder: "Describe the situation (e.g., Outage for 2 hours, whole neighborhood affected...)",
    report_submit: "Report outage",
    report_success: "Outage reported successfully!",
    report_error: "Error reporting outage",
    report_login_required: "Login to report an outage",
  },
  
  sw: {
    // Navigation
    nav_application: "Programu",
    nav_services: "Huduma",
    nav_contact: "Wasiliana",
    nav_login: "Ingia",
    nav_logout: "Toka",
    nav_dashboard: "Dashibodi",
    
    // Hero Section
    hero_location: "Lubumbashi, DRC",
    hero_title_1: "Fuatilia",
    hero_title_2: "kukatika",
    hero_title_3: "kwa wakati halisi",
    hero_description: "Programu ya jamii ya kuripoti na kufuatilia kukatika kwa umeme (SNEL) na maji (REGIDESO) huko Lubumbashi",
    hero_download: "Pakua Programu ya Android",
    hero_web_access: "Ufikiaji wa Wavuti",
    hero_ios_soon: "Programu ya iOS inakuja hivi karibuni",
    
    // Features Section
    features_title: "Kwa nini",
    features_title_highlight: "Safi Energy",
    features_subtitle: "Suluhisho la jamii kudhibiti vyema kukatika kwa huduma muhimu",
    feature_realtime: "Wakati halisi",
    feature_realtime_desc: "Pokea tahadhari za papo hapo kuhusu kukatika katika mtaa wako",
    feature_community: "Jamii",
    feature_community_desc: "Ripoti na shiriki habari na majirani zako",
    feature_map: "Ramani shirikishi",
    feature_map_desc: "Ona maeneo yaliyoathirika kwenye ramani ya kina",
    feature_reliable: "Kuaminika",
    feature_reliable_desc: "Data iliyothibitishwa na jamii kwa usahihi zaidi",
    
    // Services Section
    services_title: "Huduma",
    services_title_highlight: "Zetu",
    services_subtitle: "Suluhisho za nishati ya jua zinazotegemeka na endelevu kwa uhuru wako wa nishati",
    service_batteries: "Betri za Jua",
    service_batteries_desc: "Betri za Lithium (LiFePO4) za ubora wa juu, zinazotoa maisha ya zaidi ya miaka 5",
    service_batteries_feature1: "Umeme masaa 24/7",
    service_batteries_feature2: "Utendaji wa hali ya juu ulioidhinishwa",
    service_panels: "Paneli za Jua",
    service_panels_desc: "Paneli za jua za 610W za utendaji wa juu kwa uzalishaji bora",
    service_panels_feature1: "Ufanisi bora",
    service_panels_feature2: "Zinastahimili hali ya hewa",
    service_installation: "Ufungaji",
    service_installation_desc: "Ufungaji wa kitaalamu na timu zetu zilizoidhinishwa huko Lubumbashi na mazingira",
    service_installation_feature1: "Timu ya kitaalamu",
    service_installation_feature2: "Huduma baada ya mauzo",
    
    // CTA Section
    cta_title: "Pakua programu",
    cta_title_highlight: "sasa",
    cta_description: "Jiunge na jamii ya Safi Energy na uendelee kupata habari kuhusu kukatika kwa umeme na maji katika eneo lako",
    cta_download: "Pakua APK",
    cta_web: "Toleo la Wavuti",
    
    // Contact Section
    contact_title: "Wasiliana",
    contact_title_suffix: " nasi",
    contact_description: "Timu yetu inapatikana kujibu maswali yako yote kuhusu huduma zetu na suluhisho za nishati.",
    contact_address: "Anwani",
    contact_phone: "Simu",
    contact_email: "Barua pepe",
    contact_zone_title: "Eneo la huduma",
    contact_zone_description: "Tunafanya kazi katika mikoa ifuatayo:",
    contact_follow: "Tufuate",
    
    // Footer
    footer_tagline: "Nishati mbadala",
    footer_copyright: "© 2024 Safi Energy. Haki zote zimehifadhiwa.",
    footer_privacy: "Sera ya Faragha",
    footer_terms: "Sheria na Masharti",
    footer_delete: "Futa Akaunti",
    
    // Dashboard
    dashboard_refresh: "Sasisha",
    dashboard_electricity: "Umeme",
    dashboard_water: "Maji",
    dashboard_total: "Jumla",
    dashboard_report: "Ripoti",
    dashboard_new_outage: "Kukatika mpya",
    dashboard_click_to_report: "Bofya kuripoti",
    dashboard_active_outages: "Kukatika kunakoendelea",
    dashboard_active_snel: "Kukatika kunakoendelea (SNEL)",
    dashboard_active_regideso: "Kukatika kunakoendelea (REGIDESO)",
    dashboard_reported: "Kukatika kuliloripotiwa",
    dashboard_map: "Ramani",
    dashboard_list: "Orodha",
    dashboard_all: "Yote",
    dashboard_no_outages: "Hakuna kukatika kuliloripotiwa",
    dashboard_all_working: "Kila kitu kinafanya kazi kawaida",
    dashboard_resolved: "Imetatuliwa",
    dashboard_severity_low: "Chini",
    dashboard_severity_medium: "Wastani",
    dashboard_severity_high: "Juu",
    
    // Auth Modal
    auth_title: "Safi Energy",
    auth_description: "Ingia au fungua akaunti kuripoti kukatika",
    auth_login_tab: "Ingia",
    auth_signup_tab: "Jisajili",
    auth_email: "Barua pepe",
    auth_password: "Nenosiri",
    auth_name: "Jina kamili",
    auth_phone: "Simu (si lazima)",
    auth_login_btn: "Ingia",
    auth_signup_btn: "Fungua akaunti",
    auth_login_success: "Umeingia kwa mafanikio!",
    auth_signup_success: "Akaunti imeundwa kwa mafanikio!",
    auth_login_error: "Hitilafu ya kuingia",
    auth_signup_error: "Hitilafu ya kuunda akaunti",
    
    // Report Outage Modal
    report_title: "Ripoti kukatika",
    report_description: "Saidia jamii yako kwa kuripoti kukatika kwa umeme au maji",
    report_type: "Aina ya kukatika",
    report_electricity: "Umeme",
    report_water: "Maji",
    report_location: "Mahali",
    report_location_placeholder: "Chagua mtaa wako",
    report_severity: "Ukali",
    report_severity_low: "Chini - Mara kwa mara",
    report_severity_medium: "Wastani - Sehemu",
    report_severity_high: "Juu - Kamili",
    report_description_label: "Maelezo",
    report_description_placeholder: "Eleza hali (mfano: Kukatika kwa masaa 2, mtaa wote umeathirika...)",
    report_submit: "Ripoti kukatika",
    report_success: "Kukatika kumeripotiwa kwa mafanikio!",
    report_error: "Hitilafu ya kuripoti kukatika",
    report_login_required: "Ingia kuripoti kukatika",
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('safi-language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('safi-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr'][key] || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sw', name: 'Kiswahili', flag: '🇹🇿' }
];
